<template>
    <Header ueberschrift="LP-THL Truppaufgabe" />
    <div id="leistungspruefung-thl-truppaufgabe">
        <div id="Geraet">
            <center>
                <h2 id="Aufgabenbezeichnung">{{this.activeAufgabe.name}}</h2>
            </center>
        </div>
        <div v-if="eingabeFahrzeug" id="EingabeFahrzeug">
            <center>
                <div class="row">
                    <div class="col-3"></div>
                    <h3 class="col-6">
                        <div id="geraetAuswahl">
                            <label for="geraete">Gerät({{ this.gefundeneGeraete }}/{{ this.anzahlGeraete }}):</label>
                            <select id="geraete" name="geraete" v-model="geraetSelected" @change="geraetChanged()">
                                <option v-for="geraet in this.geraete.filter((g) => g.aufgabenID == this.activeAufgabe.aufgabenID  && !(this.gefundeneGeraeteArray.includes(g.name)))" :value="geraet.name">{{ geraet.name }}</option>
                            </select>
                        </div>
                        <div id="fahrzeugEingabe">
                            <label for="fahrzeuge">Fahrzeug:</label>
                            <select id="fahrzeuge" name="fahrzeuge" @change="fahrzeugChanged">
                                <option value="GW">GW-L2</option>
                                <option value="TLF">TLF</option>
                            </select>
                        </div>
                    </h3>
                    <div class="col-2">
                    </div>
                    <div class="col-1"></div>
                </div>
                <div id="GW" class="row">
                    <!--<span class="col-1"></span>-->
                    <span class="buttonsFahrzeugLinks col-3">
                        <button style="visibility: hidden;" class="buttonTop mada buttonLinks fahrzeugButton" @click="GW('Da')">Da</button>
                        <button class="buttonLinks fahrzeugButton" @click="GW('G1')">G1</button>
                        <button class="buttonLinks fahrzeugButton" @click="GW('RC-Heb')">RC-Heben</button>
                        <button class="buttonLinks fahrzeugButton" @click="GW('RC-Zieh')">RC-Ziehen</button>
                    </span>
                    <!--<span class="col-6 fahrzeugContainer">-->
                    <img class="Fahrzeug" src="@/assets/LeistungspruefungTHL/RW.png">
                    <!--</span>-->
                    <span class="buttonsFahrzeugRechts col-3">
                        <button class="buttonTop mada buttonRechts fahrzeugButton" @click="GW('Ma')">Ma</button>
                        <button class="buttonRechts fahrzeugButton" @click="GW('G2')">G2</button>
                        <button class="buttonRechts fahrzeugButton" @click="GW('RC-Wald')">RC-Waldbr.</button>
                        <button class="buttonRechts fahrzeugButton" @click="GW('RC-Wassers')">RC-Wassers.</button>
                    </span>
                    <!--<span class="col-1"></span>-->
                </div>
                <div id="TLF" class="row">
                    <!--<span class="col-1"></span>-->
                    <span class="buttonsFahrzeugLinks col-3">
                        <button style="visibility: hidden;" class="buttonTop fahrzeugButton" @click="TLF('Da')">Da</button>
                        <button class="mada buttonLinks fahrzeugButton" @click="TLF('Da')">Da</button>
                        <button class="buttonLinks fahrzeugButton" @click="TLF('G1')">G1</button>
                        <button class="buttonLinks fahrzeugButton" @click="TLF('G3')">G3</button>
                        <button class="buttonLinks fahrzeugButton" @click="TLF('G5')">G5</button>
                    </span>
                    <img class="Fahrzeug" src="@/assets/LeistungspruefungTHL/TLF.png">
                    <span class="buttonsFahrzeugRechts col-3">
                        <button style="visibility: hidden;" class="buttonTop fahrzeugButton" @click="TLF('Ma')">Ma</button>
                        <button class="mada buttonRechts fahrzeugButton" @click="TLF('Ma')">Ma</button>
                        <button class="buttonRechts fahrzeugButton" @click="TLF('G2')">G2</button>
                        <button class="buttonRechts fahrzeugButton" @click="TLF('G4')">G4</button>
                        <button class="buttonRechts fahrzeugButton" @click="TLF('G6')">G6</button>
                        <button class="buttonRechts fahrzeugButton" @click="TLF('Heck')">Heck</button>
                    </span>
                    <!--<span class="col-1"></span>-->
                </div>
            </center>
        </div>
        <div v-if="this.eingabeAufgabe" id="eingabeAufgabe">
            <h2>{{ this.activeAufgabe.frage }}</h2>
            <button v-if="!this.antwortenActive" @click="zeigeAntworten()">Antworten zeigen</button>
            <div v-if="this.antwortenActive" id="Antworten">
                <h3 v-for="moeglichkeit in this.activeAufgabe.moeglichkeiten">{{ moeglichkeit }}</h3>
            </div>
            <button v-if="this.antwortenActive" @click="this.naechsteAufgabe()">Weiter</button>
        </div>
        <div class="Aufgabenzahl">
            <center>
                <h5 id="Aufgabe"></h5>
            </center>
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { ref, onMounted } from 'vue'
import Swal from 'sweetalert2'

export default {
    name: 'MTA2',
    components: {
        Header,
        Footer
    },
    data() {
        return {
            aufgaben:[
                {
                    aufgabenID: 1,
                    name: "Tauchmotorpumpe",
                    typ: "punkteNennen",
                    frage: "Nenne vier Punkte",
                    moeglichkeiten: [
                        "Dient voGWiegend zur Förderung von Wasser im Lenzeinsatz.",
                        "Die Pumpe ist mit Hilfe einer Mehrzweckleine (Mastwurf mit Spierenstich oder Karabinerhaken) zu Wasser zu lassen.",
                        "Der angeschlossene Druckschlauch ist knickfrei zu verlegen.",
                        "Das Schlauchende ist gegen Schlagen zu sichern.",
                        "Die Tauchmotorpumpe soll im Regelfall an einem für die FeueGWehr genormten Sromerzeuger angeschlossen werden.",
                        "Bei Stromentnahme aus einem Stromnetz ist ein Personenschutzschalter zu veGWenden.",
                        "Nach einem Einsatz der Tauchmotorpumpe ist diese mit sauberem Wasser zu spülen"
                    ],
                },
                {
                    aufgabenID: 2,
                    name: "Krankentrage / Schaufeltrage",
                    typ: "punkteNennen",
                    frage: "Nenne vier Punkte",
                    moeglichkeiten: [
                        "Die Krankentrage dient zum Transport von Verletzten oder nicht geh-fähigen Personen",
                        "Die Krankentrage wird einsatzbereit und zusammen mit einer Krankenhausdecke bereitgestellt.",
                        "Die Schaufeltrage dient zum schonenden und sicherenAufheben und Umlagern von Personen.",
 	                    "Die beiden Schaufelteile werden geöffnet, seitlich unter den Verletzten geschoben und wieder sicher verschlossen (Kontrolle).",
 	                    "Vor dem Transportieren einer Person sind die Anschnallgurte zu schließen.",
 	                    "Getragen wird in der Regel in Blickrichtung des Patienten.",
 	                    "Der Truppführer am Kopfende der Trage gibt das Kommando zum gleichmäßigen Anheben, Tragen und Absetzen.",
 	                    "Bei Verschmutzung der Trage durch Körperflüssigkeiten o. ä. ist diese nach dem Einsatz zu reinigen und zu desinfizieren."
                    ]
                },
                {
                    aufgabenID: 3,
                    name: "Trennschleifmaschine (elektrisch betrieben)",
                    typ: "punkteNennen",
                    frage: "Nenne vier Punkte",
                    moeglichkeiten: [
                        "Dient zum Trennen von Metallteilen und von Gestein.",
                        "Der Antrieb erfolgt durch Elektro- oder Verbrennungsmotor.",
                        "Beim Einsatz der Trennschleifmaschine ist ein Augenschutz (Schutzbrille) zu tragen. Das Helmvisier als Gesichtsschutz ist nicht ausreichend!",
                        "Die Trennscheiben müssen für die zu erreichenden Umfangsgeschwindigkeiten zugelassen sein. Trennscheiben mit Ablaufdatum dürfen nach dem Verfallsdatum nicht mehr veGWendet werden.",
                        "Vor Gebrauch ist die Trennscheibe auf Schäden zu kontrollieren.",
                        "Die Trennschleifmaschine darf nicht in explosionsgefährdeten Bereichen eingesetzt werden.",
                        "Personen (Verletzte) im Wirkungsbereich von Trennfunken müssen geschützt werden. Der Brandschutz ist sicherzustellen.",
                        "Vor einem Trennscheibenwechsel ist bei elektrisch betriebenen Geräten der Netzstecker zu ziehen.",
                    ]
                },
                {
                    aufgabenID: 4,
                    name: "Motorkettensäge",
                    typ: "punkteNennen",
                    frage: "Nenne vier Punkte",
                    moeglichkeiten: [
                        "Dient zum Trennen und Schneiden von Holz sowie zum Fällen von Bäumen.",
                        "Arbeiten mit Motorkettensägen dürfen nur von speziell ausgebildeten Personen durchgeführt werden.",
                        "Beim Einsatz der Motorkettensäge ist Gesichts- und Gehörschutz zu veGWenden. Schnittschutzkleidung mit rundumlaufenden Schnittschutzeinlagen ist zu tragen.",
                        "Beim Starten der Motorkettensäge ist diese auf dem Boden sicher abzustützen und festzuhalten.",
                        "Beim Sägen ist auf sicheren Stand zu achten. Der Einsatz der Motorkettensäge von tragbaren Leitern aus ist nicht zulässig.",
                        "Im Wirkungsbereich der Motorkettensäge dürfen sich keine anderen Personen aufhalten.",
                        "Nicht über Schulterhöhe arbeiten.",
                        "Zug- und Druckspannungen beim Sägen sind zu beachten."
                    ]
                },
                {
                    aufgabenID: 5,
                    name: "Hydraulische Winde (Büffelheber)",
                    typ: "punkteNennen",
                    frage: "Nenne vier Punkte",
                    moeglichkeiten: [
                        "Dient zum Heben, Senken und Drücken von Lasten, insbesondere zum Anheben. Mit ihr können zum Beispiel unter Lasten eingeklemmte Personen befreit werden.",
                        "Die Last wird durch Pumpen am verstellbaren Pumpenhebel angehoben und durch Betätigen des Handrades am Ablassventil abgelassen.",
                        "Die Last wird auf die Anhebeklaue oder Kopfplatte gesetzt. Die Winde ist mit einer flachen Fußplatte versehen (balligrunde Fußplatte als Zubehör).",
                        "Die Fußlagerplatte wird in der Regel auf eine Unterlage aus Holz gesetzt. Eine Fußlagerplatte kann alternativ veGWendet werden (Zubehör).",
                        "Die Last muss gegen Wegrutschen gesichert auf der Kopfplatte bzw. Anhebeklaue rutschsicher unterlegt sein.",
                        "Die Last muss beim Heben durch Unterbauen gesichert sein.",
                        "Unterlagen, auf die die Winde aufgestellt wird, müssen ausreichend breit und bruchsicher sein.",
                        "Die Winde darf bei VeGWendung der balligrunden Fußplatte höchstens bis zu einem Winkel von 75° zur Fußplatte genutzt werden."
                    ]
                },
                {
                    aufgabenID: 6,
                    name: "Hebekissensystem",
                    typ: "punkteNennen",
                    frage: "Nenne vier Punkte",
                    moeglichkeiten: [
                        "Hebekissensysteme sind pneumatisch betriebene Hebegeräte.",
                        "Unterschieden werden diese Systeme aufgrund verschiedener Arbeitsdrücke unter 1 bar bzw. größer 1 bar (gebräuchlich 8 bis 10 bar).",
                        "Die Druckkissen sind vor scharfen Kanten und Spitzen, die Beschädigungen verursachen können, zu schützen.",
                        "Angehobene Lasten sind durch einen geeigneten Unterbau zu sichern.",
                        "Ein Fallen von Lasten auf gefüllte Druckkissen ist zu vermeiden.",
                        "Die Last muss gegen Wegrutschen gesichert sein.",
                        "Druckkissen sind möglichst ganz unter die Last zu schieben, mindestens aber 75% der Kissenfläche müssen unter der Last liegen.",
                        "Bei Druckkissen unter 1 bar Betriebsdruck sollten wegen der besseren Standsicherheit zwei Druckkissen nebeneinander eingesetzt werden.",
                        "Werden zwei Kissen übereinander gelegt, muss das untere Kissen zuerst befüllt werden.",
                        "Auf stabile Lage der Last ist besonders zu achten!"
                    ]
                },
                {
                    aufgabenID: 7,
                    name: "Hydraulischer Rettungssatz",
                    typ: "punkteNennen",
                    frage: "Nenne vier Punkte",
                    moeglichkeiten: [
                        "Ein Rettungssatz besteht entweder aus einem separaten Spreizer und einer Rettungsschere, eventuell ergänzt durch einen oder mehrere Rettungszylinder oder einem Kombigerät.",
                        "Die motorbetriebene Hydraulikpumpe wird an der Einsatzstelle so aufgestellt, dass für die Hydraulikschläuche genügend Bewegungsfreiheit verbleibt.",
                        "Die Steckkupplungen der Hydraulikschläuche sind gegen Verschmutzungen zu schützen. Sie dürfen nicht unverbunden bzw. ohne Staubschutzkappe auf dem Boden abgelegt werden.",
                        "Bei Arbeiten mit hydraulischen Rettungsgeräten ist Gesichtsschutz zu tragen.",
                        "Hydraulische Rettungsgeräte nicht verkanten. Das Schneidgerät darf nicht an gehärteten Metallen eingesetzt werden.",
                        "Der Spreizer soll zum Spreizen nur mit den dafür vorgesehenen Spreizerspitzen mit Außenriffelung veGWendet werden. Bei der VeGWendung von anderen Spitzen sind die Herstellerangaben zu beachten.",
                        "Beim Einsatz der Rettungszylinder ist Fuß- und Kopfteil des Zylinders sicher an Last und Festpunkt anzusetzen. Zylinderrohr und Kolbenstange dürfen nicht auf Biegung beansprucht werden.",
                        "Sollten mehrere hydraulische Rettungsgeräte an einem Objekt zum Einsatz kommen, ist darauf zu achten, dass sich die Auswirkungen nicht gegenseitig negativ beeinflussen."
                    ]
                },
                {
                    aufgabenID: 8,
                    name: "Mehrzweckzug",
                    typ: "punkteNennen",
                    frage: "Nenne vier Punkte",
                    moeglichkeiten: [
                        "Der Mehrzweckzug wird zum Ziehen, Heben, Ablassen und Sichern von Lasten veGWendet.",
                        "Die zulässige Belastung des Mehrzweckzugs ist zu beachten.",
                        "Das Zugseil darf nicht als Anschlagseil veGWendet werden.",
                        "Der Mehrzweckzug wird in der Regel mit einem Anschlagmittel (Zubehör) an einem Festpunkt befestigt. Als Festpunkt können auch Erdanker veGWendet werden.",
                        "Das Zugseil darf nicht über Kanten geführt oder geknickt werden.",
                        "Wenn die Überlastsicherung (Scherstifte) wirksam geworden ist, ist nur noch Entlasten möglich. Die Last muss dann abgesichert oder abgelassen werden.",
                        "Das Zugseil darf erst dann von der Zugvorrichtung gelöst werden, wenn es entlastet und von der Last getrennt ist.",
                        "Zu unter Last stehenden Seilen ist ein Sicherheitsabstand von mindestens dem 1,5-fachen Radius der wirksamen Seillänge einzuhalten."
                    ]
                },
                {
                    aufgabenID: 9,
                    name: "Flutlichtstrahler mit Stativ",
                    typ: "punkteNennen",
                    frage: "Nenne vier Punkte",
                    moeglichkeiten: [
                        "Flutlichtstrahler dienen dem großflächigen Ausleuchten von Einsatzstellen.",
                        "Die Einsatzstelle soll blend- und schattenfrei ausgeleuchtet werden.",
                        "Flutlichtstrahler dürfen nicht in Bereichen mit explosionsfähiger Atmosphäre eingesetzt werden.",
                        "Zum Aufbau von mobilen Flutlichtstrahlern werden Abzweigstück, Flutlichtstrahler, Aufnahmebrücke und Stativ einschließlich Sturmverspannung benötigt.",
                        "Abstrahlwinkel und Neigung der Flutlichtstrahler wird eingestellt. Danach die Sturmverspannung am Stativ befestigt und im Regelfall ganz ausgeschoben.",
                        "Nach dem Einsatz der Flutlichtstrahler soll dieser mindestens 10 Minuten abkühlen, bevor er abgebaut und im Fahrzeug verlastet wird.",
                        "Stecker und Steckdose sind miteinander zu arretieren.",
                        "Flutlichtstrahler nicht werfen, nicht anspritzen, Erschütterungen vermeiden."
                    ]
                },
                {
                    aufgabenID: 10,
                    name: "Stabile Seitenlage",
                    typ: "punkteNennen",
                    frage: "Nenne Punkte",
                    moeglichkeiten: [
                        "Person ansprechen und berühren.",
                        "Die stabile Seitenlage wird bei Bewusstlosen mit ausreichender Atmung und Kreislauf angewandt.",
                        "Vor dem Überstrecken des Kopfes eine Mundraumkontrolle durchführen (ggf. Fremdkörper und Gebiss entfernen).",
                        "Kopf überstrecken, Atmung kontrollieren.",
                        "Eigenschutz beachten: Infektionsschutzhandschuhe tragen.",
                        "Wärmeerhalt mit Krankenhaus-/Rettungsdecke.",
                        "Rettungsdienst nachfordern.",
                        "Der Bewusstlose muss bis zum Eintreffen des Notarztes oder des Rettungsdienstes ständig übeGWacht werden."
                    ]
                }
            ],
            geraete: [
            {
                name: "Tauchmotorpumpe",
                aufgabenID: 1,
                FachGW: "RC-Wassers",
                FachTLF: "" 
            },
            {
                name: "Druckschlauch",
                aufgabenID: 1,
                FachGW: "",
                FachTLF: "G2" 
            },
            {
                name: "Personenschutzschalter",
                aufgabenID: 1,
                FachGW: "RC-Wassers",
                FachTLF: "" 
            },
            {
                name: "Mehrzweckleine",
                aufgabenID: 1,
                FachGW: "RC-Wassers",
                FachTLF: "Ma" 
            },
            {
                name: "Schlauchhalter",
                aufgabenID: 1,
                FachGW: "",
                FachTLF: "Heck" 
            },
            {
                name: "Krankentrage",
                aufgabenID: 2,
                FachGW: "G2",
                FachTLF: "Ma" 
            },
            {
                name: "Krankenhausdecke",
                aufgabenID: 2,
                FachGW: "Ma",
                FachTLF: "Ma" 
            },
            {
                name: "Schaufeltrage mit Fixiergurten",
                aufgabenID: 2,
                FachGW: "",
                FachTLF: "Da" 
            },
            {
                name: "Trennschleifmaschine",
                aufgabenID: 3,
                FachGW: "G2",
                FachTLF: "" 
            },
            {
                name: "Schutzbrille",
                aufgabenID: 3,
                FachGW: "G2",
                FachTLF: "G1" 
            },
            {
                name: "Gehörschutz (Kopfbügel oder Ohrstöpsel)",
                aufgabenID: 3,
                FachGW: "G2",
                FachTLF: "" 
            },
            {
                name: "Werkzeug zum Scheibenwechsel",
                aufgabenID: 3,
                FachGW: "G2",
                FachTLF: "" 
            },
            {
                name: "Ersatztrennscheiben (für Metall und Stein)",
                aufgabenID: 3,
                FachGW: "G2",
                FachTLF: "" 
            },
            {
                name: "Motorkettensäge",
                aufgabenID: 4,
                FachGW: "G1",
                FachTLF: "" 
            },
            {
                name: "Schnittschutzkleidung",
                aufgabenID: 4,
                FachGW: "G1",
                FachTLF: "" 
            },
            {
                name: "Waldarbeiterhelm oder FeueGWehrhelm mit Gesichts- und Gehörschutz",
                aufgabenID: 4,
                FachGW: "G1",
                FachTLF: "" 
            },
            {
                name: "Reservekanister mit Kraftstoff und Kettenöl",
                aufgabenID: 4,
                FachGW: "G1",
                FachTLF: "" 
            },
            {
                name: "Ersatzkette",
                aufgabenID: 4,
                FachGW: "G1",
                FachTLF: "" 
            },
            {
                name: "Werkzeug (Kettensäge)",
                aufgabenID: 4,
                FachGW: "G1",
                FachTLF: "Ma" 
            },
            {
                name: "Hydraulische Winde",
                aufgabenID: 5,
                FachGW: "RC-Heb",
                FachTLF: "" 
            },
            {
                name: "Fußlagerplatte (wenn vorhanden)",
                aufgabenID: 5,
                FachGW: "RC-Heb",
                FachTLF: "" 
            },
            {
                name: "Hartholzunterlegklotz",
                aufgabenID: 5,
                FachGW: "G2",
                FachTLF: "" 
            },
            {
                name: "Unterbaumaterial",
                aufgabenID: 5,
                FachGW: "G2",
                FachTLF: "" 
            },
            {
                name: "Hebekissen",
                aufgabenID: 6,
                FachGW: "",
                FachTLF: "G4" 
            },
            {
                name: "Druckluftflasche",
                aufgabenID: 6,
                FachGW: "",
                FachTLF: "G3" 
            },
            {
                name: "Steuerteil",
                aufgabenID: 6,
                FachGW: "",
                FachTLF: "G4" 
            },
            {
                name: "Luftschläuche",
                aufgabenID: 6,
                FachGW: "",
                FachTLF: "G4" 
            },
            {
                name: "Unterbaumaterial",
                aufgabenID: 6,
                FachGW: "G2",
                FachTLF: "" 
            },
            {
                name: "Motoerbetriebene Hydraulikpumpe",
                aufgabenID: 7,
                FachGW: "G2",
                FachTLF: "G1" 
            },
            {
                name: "Schneidgerät",
                aufgabenID: 7,
                FachGW: "G2",
                FachTLF: "G1" 
            },
            {
                name: "Spreizer",
                aufgabenID: 7,
                FachGW: "G2",
                FachTLF: "G1" 
            },
            {
                name: "Rettungszylinder",
                aufgabenID: 7,
                FachGW: "G2",
                FachTLF: "G1" 
            },
            {
                name: "Unterlage zum Schutz gegen tropfendes Hydrauliköl (z. B. Geräteplane)",
                aufgabenID: 7,
                FachGW: "G2",
                FachTLF: "G5" 
            },
            {
                name: "Mehrzweckzug",
                aufgabenID: 8,
                FachGW: "RC-Zieh",
                FachTLF: "" 
            },
            {
                name: "Zubehör",
                aufgabenID: 8,
                FachGW: "RC-Zieh",
                FachTLF: "" 
            },
            {
                name: "Anschlagmittel: Drahtseil/Rundschlinge/Schäkel",
                aufgabenID: 8,
                FachGW: "RC-Zieh",
                FachTLF: "" 
            },
            {
                name: "Flutlichtstrahler mit Aufnahmebrücke oder Beleuchtungseinheit",
                aufgabenID: 9,
                FachGW: "",
                FachTLF: "G4" 
            },
            {
                name: "Stativ",
                aufgabenID: 9,
                FachGW: "",
                FachTLF: "G2" 
            },
            {
                name: "Leitungstrommel mit Abzweigstück oder Leitungsroller",
                aufgabenID: 9,
                FachGW: "",
                FachTLF: "G4" 
            },
            {
                name: "Abspannleinen",
                aufgabenID: 9,
                FachGW: "",
                FachTLF: "G4" 
            },
            {
                name: "Krankenhausdecke/Rettungsdecke",
                aufgabenID: 10,
                FachGW: "Ma",
                FachTLF: "Ma" 
            },
            {
                name: "Verbandskasten",
                aufgabenID: 10,
                FachGW: "",
                FachTLF: "Ma" 
            }
        ],
            fehler: 0,
            index: 0,
            gefundeneGeraete: 0,
            anzahlGeraete: 0,
            activeGeraet: {},
            activeAufgabe: {},
            eingabeFahrzeug: true,
            antwortenActive: false,
            gefundeneGeraeteArray: [],
        }
    },
    methods: {
        startGame: function () {
            this.index = 0;
            this.fehler = 0;
            this.gefundeneGeraete = 0;
            this.eingabeFahrzeug = true;
            this.eingabeAufgabe = false;
            this.antwortenActive = false;
            this.aufgaben = this.shuffle(this.aufgaben);
            this.activeAufgabe = this.aufgaben[0];
            this.getAnzahlGeraete(this.activeAufgabe.aufgabenID);
        },
        getAnzahlGeraete(aufgabenID){
            var i = 0;
            var counter = 0;
            while(i < this.geraete.length){
                if(this.geraete[i].aufgabenID == aufgabenID){
                    counter++;
                }
                i++;
            }
            this.anzahlGeraete = counter;
        },
        erhoeheGefundeneGeraete(){
            this.gefundeneGeraete++;
            if(this.gefundeneGeraete >= this.anzahlGeraete){
                this.zeigeAufgabe();
            }
        },
        zeigeAufgabe: function () {
            this.eingabeFahrzeug = false;
            this.eingabeAufgabe = true;
        },
        zeigeAntworten(){
            this.antwortenActive = true;
        },
        naechsteAufgabe(){
            if(this.index < this.aufgaben.length - 1){
                this.index++;
                this.activeAufgabe = this.aufgaben[this.index];
                this.gefundeneGeraete = 0;
                this.anzahlGeraete = 0;
                this.eingabeFahrzeug = true;
                this.eingabeAufgabe = false;
                this.antwortenActive = false;
                this.getAnzahlGeraete(this.activeAufgabe.aufgabenID);
                this.gefundeneGeraeteArray = [];
            } else{
                this.zeigeErgebnis();
            }
        },
        zeigeErgebnis(){
            Swal.fire(
                    'Du hast es geschafft',
                    'Du hast ' + this.fehler + ' Fehler',
                    'info'
                )
            this.startGame();
        },
        fahrzeugChanged: function () {
            var fahrzeug = document.getElementById("fahrzeuge").options[document.getElementById("fahrzeuge").selectedIndex].text;

            if (fahrzeug == "GW-L2") {
                this.activateGW();
                this.deactivateTLF();
            } else if (fahrzeug == "TLF") {
                this.activateTLF();
                this.deactivateGW();
            }
        },
        geraetChanged: function(){
            this.activeGeraet = this.geraete.filter((g) => g.aufgabenID == this.activeAufgabe.aufgabenID && !(this.gefundeneGeraeteArray.includes(g.name)))[document.getElementById("geraete").selectedIndex];
        },

        activateGW: function () {
            document.getElementById("GW").style.display = "flex";
        },

        activateTLF: function () {
            document.getElementById("TLF").style.display = "flex";
        },

        deactivateGW: function () {
            document.getElementById("GW").style.display = "none";
        },

        deactivateTLF: function () {
            document.getElementById("TLF").style.display = "none";
        },

        GW: function (Gate) {
            console.log(Gate);
            console.log(this.activeGeraet);
            if (this.activeGeraet.FachGW == Gate) {
                Swal.fire(
                    'Richtig',
                    '',
                    'success'
                )
                this.erhoeheGefundeneGeraete();
                this.gefundeneGeraeteArray.push(this.activeGeraet.name);
            } else{
                this.fehler++;
                Swal.fire(
                    'Falsch!',
                    'Das richtige Fach war auf dem GW das Fach ' + this.activeGeraet.FachGW,
                    'error'
                )
            }
        },

        TLF: function (Gate) {
            if (this.activeGeraet.FachTLF == Gate) {
                Swal.fire(
                    'Richtig',
                    '',
                    'success'
                )
                this.erhoeheGefundeneGeraete();
                this.gefundeneGeraeteArray.push(this.activeGeraet.name);
            } else{
                this.fehler++;
                Swal.fire(
                    'Falsch!',
                    'Das richtige Fach war auf dem TLF das Fach ' + this.activeGeraet.FachTLF,
                    'error'
                )
            }
        },

        shuffle: function (array) {
            let counter = array.length;

            // While there are elements in the array
            while (counter > 0) {
                // Pick a random index
                let index = Math.floor(Math.random() * counter);

                // Decrease counter by 1
                counter--;

                // And swap the last element with it
                let temp = array[counter];
                array[counter] = array[index];
                array[index] = temp;
            }

            return array;
        }
    },
    created() {
    },
    mounted() {
        //document.onreadystatechange = () => {
            this.startGame();
        //}
    }
}
</script>

<style lang="scss">
#leistungspruefung-thl-truppaufgabe {
    display: block !important;
    position:absolute !important;
    height:auto !important;
    bottom:0 !important;
    top:0 !important;
    left:0 !important;
    right:0 !important;
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
    padding-left: 1rem;
    padding-right: 1rem;
    margin-top: 4.5rem;
    height: 72vh;
    overflow-y: scroll;
    background-color: white;

    .Ueberschrift {
        text-align: center;
    }

    #GW,
    #TLF {
        /* font-family:'Courier New', Courier, monospace !important; */
        display: flex;
        justify-content: center;
    }

    #TLF {
        display: none;
    }

    .buttonsFahrzeugLinks {
        height: 100%;
        padding-right: 0px !important;
    }

    .buttonsFahrzeugRechts {
        height: 100%;
        padding-left: 0px !important;
    }

    .buttonTop {
        margin-top: 1rem;
    }

    .fahrzeugButton {
        display: inline-block;
        /*width: 3.8rem;*/
        width: 26vw;
        height: 3.8rem;
        margin-bottom: 0.15rem !important;
        font-size: 1.4rem !important;
    }

    .buttonRechts {
        border-right: 3px solid black;
        border-top: 3px solid black;
        border-bottom: 3px solid black;
        background-color: inherit;
        color: black;
        border-left: transparent;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        outline: none !important;


        border-left: 3px solid black;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }

    .buttonLinks {
        border-left: 3px solid black;
        border-top: 3px solid black;
        border-bottom: 3px solid black;
        background-color: inherit;
        color: black;
        border-right: transparent;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        outline: none !important;


        border-right: 3px solid black;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }

    .mada {
        margin-bottom: 2rem !important;
    }

    .Fahrzeug {
        /*height: auto;
    width: 100% !important;
    max-width:80% !important;*/
        height: 25rem;
        width: auto;
    }

    .fahrzeugContainer {
        padding: 0px !important;
    }
}
</style>